import React from 'react'

import Loader from 'content-components/_Primatives/Loader'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type Props = {
  children: React.ReactNode
  isLoading: boolean
  noResultsFoundText: string
}

function SimpleDailyList(props: Props) {
  const { children, isLoading, noResultsFoundText } = props

  return isLoading ? (
    <Loader />
  ) : (
    <div className={style.wrapper}>
      {children ? (
        <>
          <div>{children}</div>
        </>
      ) : (
        <Paragraph>{noResultsFoundText}</Paragraph>
      )}
    </div>
  )
}

export default SimpleDailyList
